let settingVue = null;
export default {
  get(){
    return settingVue;
  },
  set(settings){
    settingVue = settings;
  }
}



// WEBPACK FOOTER //
// ./src/framework/setting.js